import React, { useMemo } from 'react';
import classNames from 'classnames';
import { getLocale } from 'umi';
import { formatRatio } from '../../utils/eventBlockUtils';

interface IEventHeaderProps {
  /** 标题 */
  title: string;

  /** 描述（可选） */
  description?: string;

  /** 比例值 */
  ratio?: number;

  /** 是否悬停/选中状态（影响颜色） */
  isActive?: boolean;

  /** 趋势方向 */
  trend?: 'up' | 'down' | 'mixed';

  /** 标签名称 */
  tagName?: string;

  /** 标签名称（中文） */
  tagNameZh?: string;

  /** 标签名称（英文） */
  tagNameEn?: string;

  /** 趋势文案（多语言，按趋势方向配置） */
  trendText?: Partial<Record<'up' | 'down' | 'mixed', Record<'zh-CN' | 'en-US', string>>>;
}

export function EventHeader({
  title,
  description,
  ratio,
  isActive,
  trend,
  tagName,
  tagNameZh,
  tagNameEn,
  trendText,
}: IEventHeaderProps) {
  const ratioInfo = useMemo(() => formatRatio(ratio), [ratio]);

  // 根据语言环境获取标签名称
  const locale = getLocale();
  const isEnglish = locale === 'en-US';
  const displayTagName = isEnglish
    ? (tagNameEn || tagName)
    : (tagNameZh || tagName);

  const trendLocaleKey = isEnglish ? 'en-US' : 'zh-CN';
  const trendLabel = trend && trendText?.[trend]
    ? trendText?.[trend]?.[trendLocaleKey]
    : undefined;

 

  return (
    <div className="dbo-hp-header">
      {displayTagName && (
        <div className="dbo-hp-region">{displayTagName}</div>
      )}
      <div className="dbo-hp-title-row">
        <h4 className="dbo-hp-title">{trendLabel || title}</h4>
        {ratioInfo && (
          <div className="dbo-hp-header-ratio">
            <span>{ratioInfo.value}</span>
            {ratioInfo.arrow && (
              <span className="dbo-hp-ratio-arrow">{ratioInfo.arrow}</span>
            )}
          </div>
        )}
      </div>
      {!trendLabel && title && (
        <p className="dbo-hp-description">{title}</p>
      )}
    </div>
  );
}
